import { useCallback, useState } from "react";
import {
  readSidebarCollapsedPreference,
  writeSidebarCollapsedPreference,
} from "./sidebar-collapsed-preference.js";

/**
 * Desktop-only sidebar collapse preference backed by localStorage.
 * Responsive tablet/mobile presentation should gate on viewport separately
 * and must not call the setter unless the user explicitly toggles on desktop.
 */
export function useSidebarCollapsedPreference(): [
  boolean,
  (collapsed: boolean) => void,
] {
  const [collapsed, setCollapsedState] = useState(() => readSidebarCollapsedPreference());

  const setCollapsed = useCallback((next: boolean) => {
    setCollapsedState(next);
    writeSidebarCollapsedPreference(next);
  }, []);

  return [collapsed, setCollapsed];
}
